var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_vm._l((_vm.rows),function(row,index){return [_c('md-table-row',{key:index},[(
          !index ||
            _vm.rows[index - 1].travel_season_id != _vm.rows[index].travel_season_id
        )?_c('md-table-cell',{attrs:{"rowspan":2}},[_vm._v(_vm._s(row.travel_season))]):_vm._e(),_c('md-table-cell',[_vm._v(_vm._s(row.demand_type == "HIGH_DEMAND" ? "HD" : "LD"))]),_vm._t("default",null,{"row":row})],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }